/* eslint-disable @typescript-eslint/no-explicit-any */
import { Box, Button } from "@mui/material";
import React, { useEffect, useState } from "react";
import GooglePlay from '../assets/icons/googleplay.png';

const InstallPWA: React.FC = () => {

  const [supportsPWA, setSupportsPWA] = useState(false);
  const [promptInstall, setPromptInstall] = useState<any | null>(null);

  useEffect(() => {
    const handler = (e: Event) => {
      e.preventDefault();
      setSupportsPWA(true);
      setPromptInstall(e);
    };
    window.addEventListener("beforeinstallprompt", handler);

    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, []);

  const onClick = (evt: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    evt.preventDefault();
    if (!promptInstall) {
      return;
    }
    (promptInstall as any).prompt();
  };

  

  return (
    !window.matchMedia('(display-mode: standalone)').matches ?
      <Button
        title="Use Google Chrome to install the app"
        onClick={onClick}
        sx={{
          width:'200px', 
          height: '50px', 
          background:'#000', 
          borderRadius: '10px', 
          color: '#FFF',
          alignSelf: 'center',
          ":hover" :{
            background:'#060505', 
          }
        }}
      >
        <Box
          component={'img'}
          src={GooglePlay}
          sx={{width:'30px', height: '30px', marginRight: '10px'}}
        />
        Get App for Android  
      </Button>
      :
      <></>
  );
};

export default InstallPWA;
